import React from 'react';
import PropTypes from 'prop-types';
import { Container, Row, Col } from 'react-bootstrap';
import { BUILDER } from 'shared/abilities';
import { compose } from 'utils/react';
import { section } from '../decorators';
import styles from './styles.scss';

const propTypes = {
  sectionStyle: PropTypes.object,
};

const Divider = ({ sectionStyle = {} }) => (
  <div style={{ ...sectionStyle }}>
    <Container>
      <Row>
        <Col xs={12}>
          <div className={styles.divider} />
        </Col>
      </Row>
    </Container>
  </div>
);

Divider.propTypes = propTypes;

const component = compose(
  section(
    { name: 'Section Divider Line', category: 'Content Layout' },
  ),
)(Divider);

component.authorization = { action: 'manage', subject: BUILDER };

export default component;
